<template>
    <div class="tile" :class="{ '-is-open': open }">
        <div class="tile__label" @click="$emit('open')">
            <div class="tile__name">
                {{ name }}:
            </div>
            <div class="tile__value">
                <slot name="value"></slot>
            </div>
        </div>

        <transition name="fade">
            <div v-if="open" class="tile__dropdown boxshadow-m" v-on-clickaway="close">
                <slot name="dropdown"></slot>
            </div>
        </transition>
    </div>
</template>

<script>
import { directive as onClickaway } from 'vue-clickaway';

export default {
    name: 'TileDrop',
    props: {
        name: String,
        open: Boolean,
    },
    methods: {
        close() {
            this.$emit('open');
        },
    },
    directives: {
        onClickaway,
    },
};
</script>

<style>
    .tile {
        z-index: 2;
    }
        .tile.-is-open { z-index: 5; }

    .tile__label, .tile__dropdown {
        background: #fff;
        border-radius: 0.7rem;
        padding: 0.6rem 1rem 0.4rem;
        border: 0.1rem solid #d1d1d1;
        transition: background .3s ease;
    }
        .tile__label {
            margin: 0.2rem;
            cursor: pointer;
        }
            .tile__label:hover {
                background-color: var(--color-bg);
            }
        .tile__name {
            color: var(--color-primary-lighter);
            font-size: var(--size-5);
            display: inline-block;
            margin-right: 0.4rem;
        }
        .tile__value {
            display: inline-block;
        }

    .tile__dropdown {
        width: 95vw;
        max-width: 30rem;
        position: absolute;
        left: 0;
        top: 100%;
        padding: 1.2rem 1.6rem;
        z-index: 10;
    }
        .tile__dropdown h4 {
            margin-bottom: 0.8rem;
        }

    @media (min-width: 50em) {
        .tile { position: relative; }
        .tile__dropdown::before {
            content: '';
            width: 1.4rem;
            height: 1.4rem;
            background: #fff;
            position: absolute;
            left: 1.4rem;
            top: -0.7rem;
            transform: rotate(45deg);
        }
    }

    @media (max-width: 49.9em) {
        .tile__dropdown {
            max-width: none;
            left: 0.8rem; right: 0.8rem;
            top: 100%;
            width: auto;
        }
    }
</style>
